import * as React from 'react';
import withStyles from 'react-jss';
import { Drawer, Icon, message, Tag, Tooltip } from 'antd';
import { StylesProps } from 'src/Library/Types';
import { useGenericState } from 'src/Library/UseGenericState';
import { getVesselTracking } from './VesselTracking.api';
import { accessIconMap, statusColorMap, statusMap } from '../../AirCargo/AirCargoUtils';
import { GOOGLE_PLACES_API_URL } from 'src/globals';
import { CardData } from '../Interfaces/Shipment.interface';
import { getFromNow } from 'src/Library/Helper';
import VesselTracking from './VesselTracking';
import { VesselTrackingObject } from './VesselTracking.interface';
import { CTPermissions } from '../Interfaces/TypesInShipmentTracking';
import ShareTracking from '../ShareTracking';
import MapWithMarkerAndTooltip from './MapWithMarkerAndTooltip';
import { colorStatusMapping } from 'src/colorScheme/containerStatus';
import { tokens } from 'src/design-system';
import { STATUS_LABELS } from '../ContainerUtils';
const styles = (theme) => ({
  dot: {
    height: 8,
    width: 8,
    borderRadius: '50%',
    backgroundColor: tokens.colors.primary,
    display: 'inline-block',
    marginRight: 5,
  },
  line: {
    height: '0',
    display: 'flex',
    flex: '1',
  },
  VTText: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.primary,
    display: 'flex',
    alignItems: 'center',
  },
  cardsDiv: {
    height: '25%',
    maxHeight: '25%',
    overflowY: 'auto',
    width: '100%',
    padding: `${tokens.spacing.ms}px 14px`,
  },
  mapDiv: {
    minHeight: '532px',
    height: '75%',
    width: '100%',
    padding: `0px 14px 18px 14px`,
  },
  mainDiv: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    width: 120,
  },
  cardDiv: {
    width: '100%',
    minHeight: '138px',
    border: '1px solid #d9d9d9',
    borderRadius: tokens.radius.md,
    cursor: 'pointer',
    marginBottom: tokens.spacing.ms,
  },
  spaceBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  access: {
    marginLeft: 5,
    color: tokens.colors.textTertiary,
    fontSize: tokens.fontSize.caption,
  },
  updatedAt: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textTertiary,
    fontStyle: 'italic',
  },
  statusPill: {
    height: 18,
    padding: '4px 10px',
    borderRadius: 9,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: tokens.fontSize.caption,
    marginLeft: 5,
    marginRight: 5,
  },
  statusPill2: {
    height: 14,
    padding: '3px 10px',
    borderRadius: 7,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 8,
  },
  valStyle: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textSecondary,
    fontWeight: 550,
    maxWidth: 90,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  labelStyle: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.textTertiary,
  },
  tooltipDiv: {
    width: 258,
    backgroundColor: tokens.colors.bgWhite,
    zIndex: tokens.zIndex.sticky,
  },
  tooltipSpaceBetween: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 6px 6px 6px',
  },
  vesselType: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textSecondary,
  },
  nextPortEta: {
    fontSize: tokens.fontSize.caption,
    color: tokens.colors.textTertiary,
    fontStyle: 'italic',
  },
  portAndCountryDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  port: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textSecondary,
    fontWeight: 550,
  },
  country: {
    fontSize: 8,
    color: tokens.colors.textTertiary,
    fontWeight: 550,
  },
  tooltipTrackingDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: tokens.spacing.sm,
    borderBottom: '1px solid rgb(217, 217, 217, 0.52)'
  },
  portAndCountry: {
    width: 64,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  trackingContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  shareIcon: {
    fontSize: tokens.fontSize.body,
    color: tokens.colors.textTertiary,
    cursor: 'pointer',
    marginRight: 5,
  },
  markAsComplete: {
    color: tokens.colors.primary,
    textDecoration: 'underline',
    fontSize: tokens.fontSize.caption,
    cursor: 'pointer',
  },
  vesselName: {
    fontSize: tokens.fontSize.small,
    color: tokens.colors.text,
    fontWeight: 550,
  },
  success: {
    backgroundColor: tokens.colors.success,
    borderColor: tokens.colors.success,
    color: tokens.colors.bgWhite,
    textTransform: 'capitalize',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
  },
  error: {
    backgroundColor: `${theme.errorColor}`,
    borderColor: `${theme.errorColor}`,
    color: tokens.colors.bgWhite,
    textTransform: 'capitalize',
    marginLeft: tokens.spacing.md,
    fontSize: tokens.fontSize.caption,
    fontWeight: tokens.fontWeight.regular,
    borderRadius: '18px',
  },
});
declare let google: any;
const { useEffect } = React; 
interface IProps extends StylesProps<ReturnType<typeof styles>> {
  container;
  permissions: CTPermissions;
  handleArchiveShipment: (items: CardData[]) => void;
  handleUnArchiveShipment: () => void;
  handleEdit: () => void;
  mainPageTabId: string;
  isVisible?: boolean;
  showButton?: boolean;
  onClose?: () => void;
}
interface StateProps {
  visible: boolean;
  vtData: any;
  currentLeg?: VesselTrackingObject;
  shareStatusModalVisible: boolean;
}
const VTSideDrawer = (props: IProps) => {
  const { classes, container, permissions, mainPageTabId, isVisible, showButton, onClose, handleUnArchiveShipment, handleArchiveShipment, handleEdit } = props;
  const [state, setState] = useGenericState<StateProps>({
    visible: isVisible || false,
    shareStatusModalVisible: false,
    vtData: {},
  });
  const {
    visible,
    vtData,
    currentLeg,
    shareStatusModalVisible,
  } = state;
  useEffect(() => {
    if (visible) {
      getVTData();
    }
  }, [visible]);
  function setCurrentLeg(currentLeg: VesselTrackingObject) {
    setState({
      currentLeg
    });
  }
  const getVTData = async () => {
    const response = await getVesselTracking({ containerId: container.containerId });
    if (response.isSuccess) {
      setState({ vtData: response.data })
    } else {
      message.error(response.errorMessage);
    }
  }
  const renderVesselAndAccess = (vesselName) => {
    const { icon, name } = accessIconMap.PUBLIC;
    return <div>
    <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 8 }}>
      <span className={classes.vesselName}>
        Voyage Vessel {vesselName} | 
      </span>
      <span className={classes.access}>
      <Icon type={icon} theme="outlined" />
      <span style={{ marginLeft: 6 }}>{name !== "Team" ? name : 'Team'}</span>
    </span>
    </div>
    <div className={classes.access} style={{ marginLeft: 0, fontStyle: 'italic' }}>
      {container?.nextPortName ? `Intended Transshipment Port ${container?.nextPortName} ` : null}
    </div>
    </div>
  }
  const renderUpdatedAtAndStatus = (item, status) => {
    return <div style={{ display: 'flex', marginTop: 8 }}>
      <span className={classes.updatedAt}>
        Updated at: {getFromNow(item[item?.length-1].updatedAt)}
      </span>
      {status && <Tag
        style={{
          borderColor: colorStatusMapping[status],
          background: colorStatusMapping[status],
          cursor: 'default',
        }}
        className={(status === 'DELAYED') ? classes.error : classes.success}>
        {`${STATUS_LABELS[status]}`}
      </Tag>}
    </div>
  }
  const renderCard = (item, vesselName, status, lastItem) => {
    return <div className={classes.cardDiv}
    style={{
      borderLeft: `3px solid ${status ? statusColorMap[status] : statusColorMap.UNAVAILABLE}`,
    }}>
      <div style={{ padding: '5px 8px 5px 8px', backgroundColor: 'rgb(236,236,236,0.18)' }} className={classes.spaceBetween}>
        {renderVesselAndAccess(vesselName)}
        {renderUpdatedAtAndStatus(item, container?.tag)}
      </div>
      <div style={{ padding: '14px 8px 8px 8px' }}>
        <VesselTracking tracking={item} currentVessel={lastItem} setCurrentLeg={setCurrentLeg} />
      </div>
    </div>
  }
  const renderCardsList = () => {
    return vtData?.orderOfVesselsInContainer?.map((item, index) => {
      const status = (index !== vtData?.orderOfVesselsInContainer?.length -1 || isCardArchived()) ? 'COMPLETED' : vtData?.currentVesselStatus;
      return renderCard(vtData.vesselLegTrackingMap[item.vessel], item.vesselName, status, index === vtData?.orderOfVesselsInContainer?.length - 1);
    });
  }
  const renderLabelValForTooltip = (label, val) => {
    return <div className={classes.tooltipSpaceBetween}>
      <span className={classes.labelStyle}>
        {label}
      </span>
      <Tooltip title={val || '-'} className={classes.valStyle}>
        {val || '-'}
      </Tooltip>
    </div>
  }
  const renderUpcomingPort = () => {
    return <div className={classes.tooltipSpaceBetween}>
      <span className={classes.labelStyle}>
        Upcoming Port
      </span>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      <Tooltip title={container.vesselArrivalPortName || '-'} className={classes.valStyle}>
        {container.vesselArrivalPortName || '-'}
      </Tooltip>
      {container.vesselNextPortEta && <span className={classes.nextPortEta }>
        ETA: {getFromNow(parseInt(container.vesselNextPortEta))}
      </span>}
      </div>
    </div>
  }
  const renderPortAndCountry = (port, countryFlag, countryName) => {
    return <div className={classes.portAndCountryDiv}>
      <div className={classes.port}>
        {port || '-'}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <img style={{ width: 15, height: 9, marginRight: 3 }} src={countryFlag} />
        <span className={classes.country}>
          {countryName || '-'}
        </span>
      </div>
    </div>
  }
  const renderDot = (color) => {
    return <span className={classes.dot}
    style={{ backgroundColor: color, marginRight: 0, border: '0.63px solid #84E54F' }}/>
  }
  const renderLine = (color) => {
    return <span
      className={classes.line}
      style={{ borderTop: `0.5px solid ${color}` }}
    />;
  };
  const renderTrackingForTooltip = () => {
    const arr: any = [];
    if (currentLeg?.atd) {
      arr.push(renderDot('#23C900'));
    } else {
      arr.push(renderDot(tokens.colors.bgWhite));
    }
    if (currentLeg?.ata) {
      arr.push(renderLine('#23C900'));
      arr.push(renderDot('#23C900'));
    } else {
      arr.push(renderLine(tokens.colors.textSecondary));
      arr.push(renderDot(tokens.colors.bgWhite));
    }
    return <div className={classes.trackingContent}>
      {arr}
    </div>
  }
  const renderShare = () => {
    const check = (
      container?.shipmentNumber ||
      (container.blNumber && !container.containerNumber) ||
      (container.bookingNumber && !container.containerNumber) ||
      (container?.containerNumber && !(container?.blNumber || container?.bookingNumber)) ||
      container?.hblNumber
    );
    if (container?.sharedByType !== 'FF' && !check) return null;
    return <Tooltip title={'Share'}>
      <Icon
        onClick={() => setState({ shareStatusModalVisible: true })}
        type="share-alt"
        className={classes.shareIcon}
      ></Icon>
    </Tooltip>;
  };
  function isCardArchived() {
    return container && container?.isArchived;
  }
  const renderEdit = () => {
    if (
      isCardArchived() ||
      !permissions.write
      // || (cardType === SHIPMENT_TYPE.CN && (container?.blNumber || container?.bookingNumber))
    ) return null;
    return <Tooltip title={'Edit'}>
      <Icon
        onClick={() => handleEdit()}
        type="edit" className={classes.shareIcon}
      />
    </Tooltip>;
  };
  const renderTooltipActions = () => {
    return <div className={classes.spaceBetween}>
      <div>
        {renderShare()}
        {renderEdit()}
      </div>
      {(isCardArchived() && !container.completionReason?.includes('has marked')) ? null :
      <div className={classes.markAsComplete} onClick={() => isCardArchived() ? handleUnArchiveShipment() : handleArchiveShipment([container])}>
        {isCardArchived() ? 'Mark as Incomplete' : 'Mark as Completed'}
      </div>}
    </div>
  }
  const renderTooltip = () => {
    return <div className={classes.tooltipDiv}>
      <div className={classes.tooltipSpaceBetween} style={{ borderBottom: '1px solid #d9d9d9', paddingBottom: 6 }}>
        <span className={classes.vesselType}>
          {container.vesselType}
        </span>
        {container?.tag && <Tag
        style={{
          borderColor: colorStatusMapping[container?.tag],
          background: colorStatusMapping[container?.tag],
          cursor: 'default',
        }}
        className={(container?.tag === 'DELAYED') ? classes.error : classes.success}>
        {`${STATUS_LABELS[container?.tag]}`}
      </Tag>}
      </div>
      <div style={{ padding: '8px' }}>
      <div className={classes.tooltipTrackingDiv}>
        <div className={classes.portAndCountry}>
          {renderPortAndCountry(currentLeg?.departurePort, currentLeg?.departurePortCountryFlag, currentLeg?.departurePortCountryCode)}
        </div>
        <div style={{ width: 130, padding: '12px 5px' }}>
          {renderTrackingForTooltip()}
        </div>
        <div className={classes.portAndCountry}>
        {renderPortAndCountry(currentLeg?.arrivalPort, currentLeg?.arrivalPortCountryFlag, currentLeg?.arrivalPortCountryCode)}
        </div>
      </div>
        <div style={{ borderBottom: '1px solid rgb(217, 217, 217, 0.52)' }}>
          {renderLabelValForTooltip('IMO Number', container.imoNumber)}
          {renderLabelValForTooltip('Vessel Name', container.vesselName)}
          {!container?.shipperId && !container?.ffId && renderLabelValForTooltip('Customer', container.customerName)}
          {!container?.shipperId && !container?.ffId && renderLabelValForTooltip('Supplier', container.supplierName)}
          {container?.shipperId && renderLabelValForTooltip('Shipper', container.shipperName)}
          {container?.ffId && renderLabelValForTooltip('FF', container.ffName)}
        </div>
        <div style={{ borderBottom: '1px solid rgb(217, 217, 217, 0.52)' }}>
          {renderUpcomingPort()}
          {renderLabelValForTooltip('Intended Transshipment Port', container?.nextPortName)}
        </div>
        {container?.sharedByType !== 'FF' && <div style={{ padding: '6px 0px 14px 0px' }} >
          {renderTooltipActions()}
        </div>}
      </div>
    </div>
  }
  const renderVTSideDrawer = () => {
    const vesselLocation = { lat: container.latitude, lng: container.longitude };
    return <Drawer
    visible={isVisible || visible}
    onClose={onClose ? onClose : () => setState({ visible: false })}
    width="60%"
    title="Vessel Tracking"
    >
    <div className={classes.cardsDiv}>
      {renderCardsList()}
    </div>
    <MapWithMarkerAndTooltip
      googleMapURL={GOOGLE_PLACES_API_URL}
      loadingElement={<div className={classes.mapDiv} />}
      containerElement={<div className={classes.mapDiv} />}
      mapElement={<div className={classes.mapDiv} />}
      zoom={3}
      center={vesselLocation}
      isOpen={true}
      markerPosition={vesselLocation}
      renderTooltip={renderTooltip}
      tag={container?.tag}
      />
    </Drawer>
  }
  return <React.Fragment>
  {/* {showButton && <div className={classes.mainDiv} onClick={() => setState({ visible: true })}>
    <span className={classes.dot} />
    <span className={classes.VTText}>
        View Vessel Tracking
    </span>
  </div>} */}
  {visible && renderVTSideDrawer()}
  {shareStatusModalVisible && <ShareTracking
    type={mainPageTabId}
    isVisible={shareStatusModalVisible}
    items={[container]}
    isSingleShare={true}
    onModalClose={() => {
      setState({
        shareStatusModalVisible: false,
      });
    }}
  />}
  </React.Fragment>
}
export default withStyles(styles)(VTSideDrawer)
